import styles from './styles.module.scss';
import 'photoswipe/dist/photoswipe.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, {useEffect, useRef, useState} from "react";

import StepNav from "../StepNav";
import {useAppData} from "../../context/Contexts";
import StepNoCompatible from '../StepNoCompatible';
import Step2New from "../Step2New";
import Step3New from "../Step3New";
import StepUpsells from "../StepUpsells";


const MainStepNew: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [incompatible, setIncompatible] = useState<boolean>(false);

    useEffect(() => {
        setIncompatible((typeof currentAppData?.check !== 'undefined'
            && (currentAppData?.check?.compatibility === 'N' || currentAppData?.check?.compatibility === 'A')
            && currentAppData?.check?.compatibility_custom === 'N'
            && currentAppData?.step > 1));
    }, [currentAppData]);

    // console.log(
    //     'incompatible=',
    //     currentAppData?.check?.compatibility,
    //     (typeof currentAppData?.check !== 'undefined' && !!currentAppData?.check?.compatibility),
    //     incompatible
    // );

    return (<>
        {!incompatible ? (<><Step2New id={props.id} stepNumber={2}/>
        <Step3New id={props.id} stepNumber={3}/>
        <StepNav id={props.id}/>
            {window.scs_new_design_2026 && window.scs_upsells && window.scs_upsells.length > 0 ?
                <StepUpsells></StepUpsells>
             : ''}
        </>): ''}
    </>);
};

export default MainStepNew;